export class AmazonLogisticsImportMappings {
    id;

    name;

    mappings;

    constructor(id, name, mappings) {
      this.id = id;
      this.name = name;
      this.mappings = mappings;
    }

    static fromDto(dto) {
      return new AmazonLogisticsImportMappings(
        dto.id,
        dto.name,
        dto.mappings,
      );
    }
}
